import { DrugTest } from "../../../Dockect/DrugTest/DrugTest";

export const GoToDrugTest = ({
  userinfo,
  toastConfig,
  setToastConfig,
  dropdownData,
  docketDropdownData,
  docketfield,
  drugTestData,
  drugTestErrorHandling,
  getrugTestDataApi,
  dockertDetail,
  gotoDrugTest,
  getDrugTestData
}) => {
  return (
    <>
      <div className="goto-drugtest-tab">
        <DrugTest
          userinfo={userinfo}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          dropdownData={dropdownData}
          docketDropdownData={docketDropdownData}
          docketfield={docketfield}
          drugTestData={drugTestData}
          drugTestErrorHandling={drugTestErrorHandling}
          getrugTestDataApi={getrugTestDataApi}
          dockertDetail={dockertDetail}
          gotoDrugTest={gotoDrugTest}
          getDrugTestData={getDrugTestData}
        />
      </div>
    </>
  );
};
